"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDescription = void 0;
var React = __importStar(require("react"));
var helpers_1 = require("../../utils/component/helpers");
function getDescription(native) {
    var description;
    if (helpers_1.isNonEmptyString(native.body)) {
        // v3
        description = native.body;
    }
    else if (helpers_1.isNonEmptyString(native.fullText)) {
        // v2
        description = native.fullText;
    }
    else if (helpers_1.isNonEmptyString(native.description)) {
        // v2
        description = native.description;
    }
    else {
        description = '';
    }
    return helpers_1.escape(description);
}
exports.getDescription = getDescription;
var Description = function (_a) {
    var native = _a.native, className = _a.className, style = _a.style;
    return (React.createElement("div", { className: className, style: style, dangerouslySetInnerHTML: { __html: getDescription(native) } }));
};
exports.default = Description;
